import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
//import { StyledTableCell } from "./CommonStyles";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 6,
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: theme.palette.common.grey,
    color: theme.palette.common.black,
    fontSize: 14,
    fontWeight: "Bold",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export function Grandtotal({ gfgcolor, csvUplaodEnabled }) {
  let cmquantity = 0;
  for (const [key, value] of Object.entries(gfgcolor)) {
    for (const [keys, values] of Object.entries(value)) {
      if (keys == "Quantity") {
        cmquantity += Number(values);
      }
    }
  }
  if (cmquantity != 0) {
    return (
      <StyledTableRow>
        {csvUplaodEnabled && <StyledTableCell scope="row"></StyledTableCell>}
        <StyledTableCell scope="row"></StyledTableCell>
        <StyledTableCell scope="row">
          <b>Grand Total</b>
        </StyledTableCell>
        <StyledTableCell>
          <b>{cmquantity}</b>
        </StyledTableCell>
      </StyledTableRow>
    );
  } else {
    return <tr></tr>;
  }
}
